import React from "react";
import cn from "classnames";

export type IconSizes = "10" | "12" | "14" | "16" | "20" | "24" | "32" | "36";

interface Props {
  className?: string;
  rotating?: boolean;
  size?: IconSizes;
  symbolId: SvgSymbolId;
}

const Icon = (props: Props): JSX.Element => {
  const className = cn("SvgIcon", props.className, {
    [`SvgIcon--s-${props.size || ""}`]: props.size,
    "SvgIcon--rotating": props.rotating,
  });
  return (
    <svg className={className}>
      <use xlinkHref={`#${props.symbolId}-symbol`}/>
    </svg>
  )
}

export default Icon;
